import { Icon } from '@zet/design-system'
import { XStack } from '@zet/design-system/layout'
import { SH3 } from '@zet/design-system/typography'
import { ScrollView } from 'react-native-gesture-handler'

type TopBenefitsType = Array<{
  tag?: string
  icon?: string
  heading?: string
  subText: Array<string>
}>

const BrandHighlightV2 = ({
  topBenefits,
}: {
  topBenefits?: TopBenefitsType
}) => {
  return (
    <ScrollView
      horizontal={true}
      showsHorizontalScrollIndicator={false}
      className="space-x-4/2"
      contentContainerStyle={{
        paddingRight: 30,
      }}
      scrollEnabled={Number(topBenefits?.length) > 1}
    >
      {topBenefits?.map((benefit, index) => {
        return (
          <XStack
            key={index}
            className="border-grays-30 bg-grays-20 px-4/2 w-44 items-center rounded border py-2"
          >
            {benefit?.icon && (
              <Icon
                key={benefit?.heading + benefit?.icon}
                type={benefit?.icon}
                size={20}
                className="mr-2"
              />
            )}
            {benefit?.subText?.map((text) => {
              return (
                <SH3 key={benefit?.heading + text} className="text-grays-80">
                  {text}
                </SH3>
              )
            })}
          </XStack>
        )
      })}
    </ScrollView>
  )
}

export default BrandHighlightV2
